import React, { useState, useEffect } from "react";
import { FiClock } from "react-icons/fi";

const CountdownTimer = ({ onComplete, time }) => {
  const [timeRemaining, setTimeRemaining] = useState(time ?? 300); // 3 minutes in seconds

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(timer);
          if (typeof onComplete === "function") {
            onComplete();
          }
          return prevTime;
        }
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [onComplete]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center space-x-2">
        <div className="bg-blue-500 text-white rounded-full p-2">
          <FiClock size={40} />
        </div>
        <div className="text-3xl font-bold">{formatTime(timeRemaining)}</div>
      </div>
    </div>
  );
};

export default CountdownTimer;
